export default __webpack_public_path__ + "static/media/phone.d3c4f912.svg";